<template>
  <div
    ref="chartBar"
    class="chart-bar"
  >
  </div>
</template>

<script>
import * as echarts from 'echarts'
import _ from 'lodash'
export default {
  data() {
    return {
      list: [],
      links: [],
      colors: ["#E7F3FF","#EBEEFF","#FFF0F3","#FFF7DF","#ECF8EE"],
      symbols: [100,90,80,70,60,50,40,40,40]
    };
  },

  props: {
    option: {
      type: Object,
      default(){
        return{}
      } 
    },
    dataType: "",
    isArray: false
  },

  watch: {
    option: {
      handler: function (val) {
        this.drawLine(val)
      },
      deep: true
    }
  },
  mounted() {
    this.drawLine(this.option);
    window.addEventListener("resize", () => {
         this.charts.resize()
    })
  },

  methods: {
    drawLine(option) {
      this.list = []
      this.links = []
      this.option.f1.forEach((v,i)=>{
        if(this.isArray){
          var len = 0;
          if(v.f0!=='地方法规' && v.f0!=='部门规章'){
            len = v.f1[0].f0
          }else{
            v.f1.forEach(ele=>{
              len += ele.f0;
            })
          }
          this.list.push({
            name: v.f0,
            value: len,
            color: this.colors[i] || "#EBEEFF"
          })
          this.links.push({
            source: this.dataType == 'isBook'?this.option.f0.title : this.option.f0.title && (/【(.*?)】/.exec(this.option.f0.title) && /【(.*?)】/.exec(this.option.f0.title)[1] || this.option.f0.title.split('条')[1] || this.option.f0.title.replace('中华人民共和国','')),
            target: v.f0,
            len: len,
            label: {
                show: true,
                formatter:"数量:"+ len +"条",
                fontSize: 12
            }
          })
        }else{
          this.list.push({
            name: v.f0,
            value: v.f1,
            color: this.colors[i] || "#EBEEFF"
          })
          this.links.push({
            source: this.dataType == 'isBook'?this.option.f0.title : this.option.f0.title && (/【(.*?)】/.exec(this.option.f0.title) && /【(.*?)】/.exec(this.option.f0.title)[1] || this.option.f0.title.split('条')[1] || this.option.f0.title.replace('中华人民共和国','')),
            target: v.f0,
            len: len,
            label: {
                show: true,
                formatter:"数量:"+ v.f1 +"条",
                fontSize: 12
            }
          })
        }  
      })

      this.list = _.sortBy(this.list,function(item){
        return -item.value;
      })
      this.links = _.sortBy(this.links,function(item){
        return item.len;
      })
      this.list.forEach((v,i)=>{
        v.symbolSize = this.symbols[i]
      })
      this.list.unshift({
        name: this.dataType == 'isBook'?this.option.f0.title : this.option.f0.title && (/【(.*?)】/.exec(this.option.f0.title) && /【(.*?)】/.exec(this.option.f0.title)[1] || this.option.f0.title.split('条')[1] || this.option.f0.title.replace('中华人民共和国','')),
        symbolSize: 120,
        color: "#3086FF",
        fontColor: "#fff",
        fontSize: 14
      })
      
      this.$nextTick(function () {
        this.charts = echarts.init(this.$refs.chartBar)
        // 指定图表的配置项和数据
        this.charts.setOption({
            animationDurationUpdate: 1500,
            animationEasingUpdate: 'quinticInOut',
            series: [
                {
                    type: 'graph',
                    layout: 'force',
                    roam: false,
                    label: {
                        show: true
                    },
                    force: {
                        edgeLength: 15, //默认距离
                        friction: 1, //减缓节点的移动速度。取值范围 0 到 1
                        repulsion: this.option.repulsion || 1800 ,//斥力,
                        layoutAnimation: false
                    },
                    edgeLabel: {
                        fontSize: 20
                    },
                    data: this.list.map(function(v){
                      return {
                        x: v.x,
                        y: v.y,
                        name: v.name,
                        value: v.value,
                        symbolSize: v.symbolSize,
                        itemStyle: {
                            color: v.color,
                            emphasis:{
                              color: v.color
                            }
                        },
                        label:{
                          show: true,
                          color: v.fontColor ||  "#222",
                          fontSize: v.fontSize || 12,
                          formatter:function(val){
                            var count = val.data.value?val.data.value+'条':''
                            var list = val.data.name && val.data.name.split('') || []
                            var str = ''
                            for(var i = 0, s; s = list[i++];) { //遍历字符串数组
                            str += s;
                            if(!(i % 4)) str += '\n'; //按需要求余
                            }
                            return str + count
                          }
                        }
                      }
                    }),
                    links: this.links.map(function(v){
                      return{
                        target: v.target,
                        source: v.source
                      }
                    }),
                    lineStyle: {
                        opacity: 0.9,
                        width: 1,
                        curveness: 0,
                        color: "rgba(48, 134, 255, 0.43)"
                    }
                }
            ]  
        })

        this.charts.off('click');
        this.charts.on('click','series', (params)=>{
          if(params.data.value){
            this.$emit('getLawInfo', params.data);
          }
        })
      });
    },
  }
}

</script>
<style scoped>
.chart-bar {
  width: 100%;
  height: 340px;
}
</style>


// WEBPACK FOOTER //
// src/components/echart/graphChart.vue